var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loadTrue
    ? _c(
        "div",
        {
          ref: "orderHome",
          staticClass: "orderHome flex flex-auto flex-column padd30 mar30_b",
          class: { homeActive: _vm.isOpenType == 0 || _vm.isOpenType == 1 }
        },
        [
          _vm.isOpenType == 0
            ? _c(
                "div",
                {
                  staticClass: "flex-auto bor-de bor_radius_10",
                  class: { mar30_b: _vm.isOpenType != 0 }
                },
                [
                  _vm._m(0),
                  _c("div", { staticClass: "padd30" }, [
                    _c("ul", { staticClass: "ul-cls flex general-store" }, [
                      _c(
                        "li",
                        {
                          staticClass:
                            "flex items-center justify-center flex-column",
                          class: { "store-active": _vm.switchType == "JC" },
                          on: {
                            click: function($event) {
                              return _vm.toAssistantSwitch("JC")
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("./images/jichu.png"),
                              alt: ""
                            }
                          }),
                          _c("div", [_vm._v("基础设置")])
                        ]
                      ),
                      _c(
                        "li",
                        {
                          staticClass:
                            "flex items-center justify-center flex-column",
                          class: { "store-active": _vm.switchType == "SP" },
                          on: {
                            click: function($event) {
                              return _vm.toAssistantSwitch("SP")
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("./images/huopin.png"),
                              alt: ""
                            }
                          }),
                          _c("div", [_vm._v("商品管理")])
                        ]
                      ),
                      _c(
                        "li",
                        {
                          staticClass:
                            "flex items-center justify-center flex-column",
                          class: { "store-active": _vm.switchType == "KH" },
                          on: {
                            click: function($event) {
                              return _vm.toAssistantSwitch("KH")
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("./images/kehu.png"),
                              alt: ""
                            }
                          }),
                          _c("div", [_vm._v("客户管理")])
                        ]
                      ),
                      _c(
                        "li",
                        {
                          staticClass:
                            "flex items-center justify-center flex-column",
                          class: { "store-active": _vm.switchType == "XS" },
                          on: {
                            click: function($event) {
                              return _vm.toAssistantSwitch("XS")
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("./images/xiaoshou.png"),
                              alt: ""
                            }
                          }),
                          _c("div", [_vm._v("销售管理")])
                        ]
                      ),
                      _vm.shopDtlEntity.shopSort == "MICRO_STORE"
                        ? _c(
                            "li",
                            {
                              staticClass:
                                "flex items-center justify-center flex-column",
                              class: { "store-active": _vm.switchType == "YX" },
                              on: {
                                click: function($event) {
                                  return _vm.toAssistantSwitch("YX")
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("./images/yingxiao.png"),
                                  alt: ""
                                }
                              }),
                              _c("div", [_vm._v("营销管理")])
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm.switchType == "JC"
                      ? _c(
                          "ul",
                          { staticClass: "mar20-t ul-cls general-step flex" },
                          [
                            _c("li", [
                              _c("div", { staticClass: "f16 fb pad10-b" }, [
                                _vm._v("店铺信息")
                              ]),
                              _c(
                                "div",
                                { staticClass: "gray9 mar10-b lin25 h50" },
                                [_vm._v("企业简介与视频等基础信息设置")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: { click: _vm.toShopIndex }
                                },
                                [_vm._v("立即查看 >")]
                              )
                            ]),
                            _c("li", [
                              _c("div", { staticClass: "f16 fb pad10-b" }, [
                                _vm._v("支付设置")
                              ]),
                              _c(
                                "div",
                                { staticClass: "gray9 mar10-b lin25 h50" },
                                [_vm._v("启用微信、支付宝、银行卡等支付")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: { click: _vm.toShopFunction }
                                },
                                [_vm._v("立即设置 >")]
                              )
                            ]),
                            _c("li", [
                              _c("div", { staticClass: "f16 fb pad10-b" }, [
                                _vm._v("配送设置")
                              ]),
                              _c(
                                "div",
                                { staticClass: "gray9 mar10-b lin25 h50" },
                                [_vm._v("设置配送模板、自提地址")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: { click: _vm.toOtherAddr }
                                },
                                [_vm._v("立即设置 >")]
                              )
                            ]),
                            _c("li", [
                              _c("div", { staticClass: "f16 fb pad10-b" }, [
                                _vm._v("运费设置")
                              ]),
                              _c(
                                "div",
                                { staticClass: "gray9 mar10-b lin25 h50" },
                                [_vm._v("可设置运费模板，用于商品的运费配置")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: { click: _vm.toFeight }
                                },
                                [_vm._v("立即设置 >")]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm.switchType == "SP"
                      ? _c(
                          "ul",
                          { staticClass: "mar20-t ul-cls general-step flex" },
                          [
                            _c("li", [
                              _c("div", { staticClass: "f16 fb pad10-b" }, [
                                _vm._v("商品设置")
                              ]),
                              _c(
                                "div",
                                { staticClass: "gray9 mar10-b lin25 h50" },
                                [_vm._v("商品的新增、编辑、上下架等管理")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: { click: _vm.toGoodsList }
                                },
                                [_vm._v("立即设置 >")]
                              )
                            ]),
                            _c("li", [
                              _c("div", { staticClass: "f16 fb pad10-b" }, [
                                _vm._v("分类管理")
                              ]),
                              _c(
                                "div",
                                { staticClass: "gray9 mar10-b lin25 h50" },
                                [_vm._v("设置商品分类及分类图标等信息")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: { click: _vm.toShopClassify }
                                },
                                [_vm._v("立即设置 >")]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm.switchType == "KH"
                      ? _c(
                          "ul",
                          { staticClass: "mar20-t ul-cls general-step flex" },
                          [
                            _c("li", [
                              _c("div", { staticClass: "f16 fb pad10-b" }, [
                                _vm._v("客户列表")
                              ]),
                              _c(
                                "div",
                                { staticClass: "gray9 mar10-b lin25 h50" },
                                [
                                  _vm._v(
                                    "店铺老客户展示、新客户引入、客户所属分组等设置"
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: { click: _vm.toCustomerNew }
                                },
                                [_vm._v("立即设置 >")]
                              )
                            ]),
                            _c("li", [
                              _c("div", { staticClass: "f16 fb pad10-b" }, [
                                _vm._v("客户分组")
                              ]),
                              _c(
                                "div",
                                { staticClass: "gray9 mar10-b lin25 h50" },
                                [_vm._v("设置客户的分组信息，用于客户分层管理")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: { click: _vm.toCustomerGroup }
                                },
                                [_vm._v("立即设置 >")]
                              )
                            ]),
                            _c("li", [
                              _c("div", { staticClass: "f16 fb pad10-b" }, [
                                _vm._v("价格方案")
                              ]),
                              _c(
                                "div",
                                { staticClass: "gray9 mar10-b lin25 h50" },
                                [_vm._v("针对不同客户设置不同的商品价格设置")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: { click: _vm.toPriceListPage }
                                },
                                [_vm._v("立即设置 >")]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm.switchType == "XS"
                      ? _c(
                          "ul",
                          { staticClass: "mar20-t ul-cls general-step flex" },
                          [
                            _c("li", [
                              _c("div", { staticClass: "f16 fb pad10-b" }, [
                                _vm._v("销售订单")
                              ]),
                              _c(
                                "div",
                                { staticClass: "gray9 mar10-b lin25 h50" },
                                [
                                  _vm._v(
                                    "查看销售订单明细、详情，对订单进行发货、售后的处理"
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.toOrderList(0)
                                    }
                                  }
                                },
                                [_vm._v("立即设置 >")]
                              )
                            ]),
                            _c("li", [
                              _c("div", { staticClass: "f16 fb pad10-b" }, [
                                _vm._v("销售汇总")
                              ]),
                              _c(
                                "div",
                                { staticClass: "gray9 mar10-b lin25 h50" },
                                [_vm._v("按商品、客户两个维度汇总展示销售数据")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: { click: _vm.toSellCollect }
                                },
                                [_vm._v("立即查看 >")]
                              )
                            ]),
                            _c("li", [
                              _c("div", { staticClass: "f16 fb pad10-b" }, [
                                _vm._v("对账单")
                              ]),
                              _c(
                                "div",
                                { staticClass: "gray9 mar10-b lin25 h50" },
                                [_vm._v("查看订单商品的收款对账信息")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: { click: _vm.toBillPage }
                                },
                                [_vm._v("立即查看 >")]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm.switchType == "YX"
                      ? _c(
                          "ul",
                          { staticClass: "mar20-t ul-cls general-step flex" },
                          [
                            _c("li", [
                              _c("div", { staticClass: "f16 fb pad10-b" }, [
                                _vm._v("广告设置")
                              ]),
                              _c(
                                "div",
                                { staticClass: "gray9 mar10-b lin25 h50" },
                                [_vm._v("设置首页的轮播广告和商品推荐")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: { click: _vm.toIndexCarouselFiguer }
                                },
                                [_vm._v("立即设置 >")]
                              )
                            ]),
                            _c("li", [
                              _c("div", { staticClass: "f16 fb pad10-b" }, [
                                _vm._v("优惠券管理")
                              ]),
                              _c(
                                "div",
                                { staticClass: "gray9 mar10-b lin25 h50" },
                                [_vm._v("添加设置优惠券活动")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: { click: _vm.toShopCoupon }
                                },
                                [_vm._v("立即创建 >")]
                              )
                            ]),
                            _c("li", [
                              _c("div", { staticClass: "f16 fb pad10-b" }, [
                                _vm._v("促销管理")
                              ]),
                              _c(
                                "div",
                                { staticClass: "gray9 mar10-b lin25 h50" },
                                [
                                  _vm._v(
                                    "店铺设置促销活动（包括直降、折扣、买赠等活动）,吸引顾客进店购买"
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: { click: _vm.toPromotionPage }
                                },
                                [_vm._v("立即创建 >")]
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              )
            : _vm._e(),
          _vm.isOpenType == 1
            ? [
                _vm.shopDtlEntity.shopSort == "ORDER_GOODS"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-auto flex-column bor-de bor_radius_10 shop_info h365",
                        class: { mar30_b: _vm.isOpenType != 1 }
                      },
                      [
                        _vm._m(1),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-auto flex-column items-center justify-center padd30"
                          },
                          [
                            _c(
                              "p",
                              { staticClass: "gray_3 f18 mar20-b t_center" },
                              [_vm._v(_vm._s(_vm.shopInfo.name))]
                            ),
                            _vm._m(2),
                            _c(
                              "p",
                              { staticClass: "clear gray_6 f14 lin_20" },
                              [
                                _c("span", { staticClass: "float-left" }, [
                                  _vm._v("主营：")
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass: "float-left ellipsis_two w290"
                                  },
                                  [_vm._v(_vm._s(_vm.businesScope))]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-auto flex-column bor-de bor_radius_10 shop_info h365",
                        class: { mar30_b: _vm.isOpenType != 1 }
                      },
                      [
                        _vm._m(3),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-auto flex-column items-center justify-center padd30"
                          },
                          [
                            _c(
                              "p",
                              { staticClass: "gray_3 f18 mar30_b t_center" },
                              [_vm._v(_vm._s(_vm.shopInfo.name))]
                            ),
                            _vm.appletInfo && _vm.appletInfo.appId != ""
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-column items-center justify-center mar10_b"
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "wx_code",
                                      attrs: { src: _vm.authUrl, alt: "" }
                                    }),
                                    _vm._m(4)
                                  ]
                                )
                              : _c(
                                  "div",
                                  [
                                    _vm._m(5),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "medium"
                                        },
                                        on: { click: _vm.toWeiXinPage }
                                      },
                                      [_vm._v(" 立即开通 ")]
                                    )
                                  ],
                                  1
                                )
                          ]
                        )
                      ]
                    ),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex-auto mar30-t bor-de bor_radius_10 shop_announcement h275"
                  },
                  [
                    _vm._m(6),
                    _vm.notice
                      ? _c(
                          "ul",
                          { staticClass: "clear padd30" },
                          [
                            _vm._l(_vm.notice, function(cont, index) {
                              return [
                                index <= 4
                                  ? _c(
                                      "li",
                                      {
                                        key: index,
                                        staticClass: "ellipsis",
                                        on: {
                                          click: function($event) {
                                            return _vm.toNotice(cont.url)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(index + 1) +
                                            ". " +
                                            _vm._s(cont.title)
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex header" }, [
      _c("div", { staticClass: "flex-auto title" }, [_vm._v("设置助手")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex header" }, [
      _c("div", { staticClass: "flex-auto title" }, [_vm._v("小程序")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex flex-column flex_ver_center mar10-b" },
      [
        _c("span", { staticClass: "gray_6 f14 flex_1 lin_20 mar10-b" }, [
          _vm._v("扫码进入小程序，推荐给您的客户，您的客户将在小程序上进行采购")
        ]),
        _c("img", {
          staticClass: "wx_code",
          attrs: {
            src:
              "https://filesouthcdn.nxin.com/nxsc_173019846074307706381249643669.JPEG",
            alt: ""
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex header" }, [
      _c("div", { staticClass: "flex-auto title" }, [_vm._v("小程序")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center mar10-t" }, [
      _c("p", { staticClass: "gray_6 f14" }, [
        _vm._v("扫码进入小程序，推荐给您的客户")
      ]),
      _c("p", { staticClass: "gray_6 f14" }, [
        _vm._v("您的客户将在小程序上进行采购")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex_ver_center mar15_b" }, [
      _c("span", { staticClass: "gray_6 f14 flex_1 lin_25 t_center" }, [
        _vm._v("开通企业专属、独立品牌微信小程序")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex header" }, [
      _c("div", { staticClass: "flex-auto title" }, [_vm._v("平台公告")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }